import { render, staticRenderFns } from "./custom-arrow.vue?vue&type=template&id=28ed4718&scoped=true"
import script from "./custom-arrow.vue?vue&type=script&lang=js"
export * from "./custom-arrow.vue?vue&type=script&lang=js"
import style0 from "./custom-arrow.vue?vue&type=style&index=0&id=28ed4718&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "28ed4718",
  null
  
)

export default component.exports